import {Vue} from 'ui.vue';
import {Vuex} from 'ui.vue.vuex';


import './BXmakerAuthuseremailSimple.css';

import './BXmakerAuthuseremailSimpleEmail';
import './BXmakerAuthuseremailSimpleCode';

import '../BXmakerAuthuseremailInput';
import '../BXmakerAuthuseremailButton';
import '../BXmakerAuthuseremailHeader';
import '../BXmakerAuthuseremailAuthorized';

Vue.component('BXmakerAuthuseremailSimple',
    {
        props: [
            'data',
        ],
        data: function () {
            return {
                email: '',
            };
        },
        computed: {
            ...Vuex.mapState('bxmaker/authuseremail/simple', [
                'rand', 'isAuthorized', 'authReloadAfter', 'isShowCodeBlock'
            ]),
        },
        methods:{
            onClickChangeEmail() {
                this.$store.commit('bxmaker/authuseremail/simple/hideCodeBlock');
                this.$store.commit('bxmaker/authuseremail/simple/resetMessage');
            },
        },
        template: `
            <div class="bxmaker-authuseremail-simple" :class="'bxmaker-authuseremail-simple--' + this.rand" :id="'bxmaker-authuseremail-simple' + this.rand" >
                
                <BXmakerAuthuseremailAuthorized v-if="isAuthorized" />
                            
                <BXmakerAuthuseremailSimpleEmail v-else-if="!isShowCodeBlock" />   
                
                <BXmakerAuthuseremailSimpleCode  v-else  @onClickChangeEmail="onClickChangeEmail" /> 
            </div>
        `,
    });